module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('portal'), _vm._v(" "), _c('launch-preview'), _vm._v(" "), (this.$route.params.type === "web") ? _c('mapchart') : _vm._e(), _vm._v(" "), _c('galaxy')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b33a5c20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medianav/medianav.vue
// module id = 451
// module chunks = 2